export const SMS = "SMS";
export const SMS_COUNT = "SMS_COUNT";
